export enum FooterType {
  STANDARD_TWO = "standardTwo",
}
